import { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { DataTableColumnHeader } from "./data-table-column-header";
import {
  TransactionListItem,
  TransactionStatus,
} from "@/services/cav-offline-sync/types";
import { formatToBRL } from "@/utils/formatToMoney";
import { formatDateTime2 } from "@/utils/format-date";
import { statusConfig } from "../constants";

export const columns: ColumnDef<TransactionListItem>[] = [
  {
    id: "select",
    header: ({ table }) => (
      <div onClick={(e) => e.stopPropagation()} className="flex items-center">
        <Checkbox
          checked={
            table.getIsAllPageRowsSelected() ||
            (table.getIsSomePageRowsSelected() && "indeterminate")
          }
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
          aria-label="Selecionar todos"
        />
      </div>
    ),
    cell: ({ row }) => (
      <div onClick={(e) => e.stopPropagation()} className="flex items-center">
        <Checkbox
          checked={row.getIsSelected()}
          onCheckedChange={(value) => row.toggleSelected(!!value)}
          aria-label="Selecionar linha"
        />
      </div>
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "store",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Loja" />
    ),
    cell: ({ row }) => row.getValue("store") ?? "-",
  },
  {
    accessorKey: "docCode",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Documento" />
    ),
    cell: ({ row }) => row.getValue("docCode") ?? "-",
  },
  {
    accessorKey: "register",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Caixa" />
    ),
    cell: ({ row }) => row.getValue("register") ?? "-",
    enableSorting: false,
  },
  {
    accessorKey: "nsu",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="NSU" />
    ),
    cell: ({ row }) => row.getValue("nsu") ?? "-",
    enableSorting: false,
  },
  {
    accessorKey: "value",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Valor" />
    ),
    cell: ({ row }) => {
      const value = row.getValue("value") as number | null;
      return value !== null ? formatToBRL(value) : "-";
    },
  },
  {
    accessorKey: "terminalDate",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Data Terminal" />
    ),
    cell: ({ row }) => formatDateTime2(row.getValue("terminalDate")),
  },
  {
    accessorKey: "status",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => {
      const status = row.getValue("status") as TransactionStatus;
      const config = statusConfig[status];
      return (
        <Badge className={`${config.className} cursor-default`}>
          {config.label}
        </Badge>
      );
    },
  },
];
